import React from "react";
import PropTypes from "prop-types";
import Select from "ManagementTeam/Shared/Select";

import styles from "./CommitteeHeader.module.css";

/**
 *  Displays Information about the committee section with options to edit and archive
 */
export function CommitteeHeader({
  title,
  description,
  year,
  archived,
  onEdit,
  onArchive,
  onDelete,
  readOnly,
}) {
  const handleDropDown = (selection) => {
    // eslint-disable-next-line default-case
    switch (selection) {
      case "Edit":
        onEdit();
        break;
      case "Archive":
        onArchive();
        break;
      case "Unarchive":
        onArchive();
        break;
      case "Delete":
        onDelete();
        break;
    }
  };
  return (
    <div className={styles.committeeHeaderContainer}>
      <div className={styles.title}>{`${title} (${year})`}</div>
      <div className={styles.body}>
        <span className={styles.description}>{description}</span>
        <span
          style={{ visibility: !readOnly ? "visible" : "hidden" }}
          className={styles.dropdown}
        >
          <Select
            placeholder="Options"
            options={
              !archived ? ["Edit", "Archive"] : ["Edit", "Unarchive", "Delete"]
            }
            onChange={handleDropDown}
          />
        </span>
      </div>
    </div>
  );
}

export const LoadingCommitteeHeader = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.loadingTitle} />
    <div className={styles.loadingBody}>
      <div className={styles.loadingDescription}>
        <div className={styles.loadingItem} />
        <div className={styles.loadingItem} />
      </div>
      <div className={styles.loadingSelect} />
    </div>
    <div className={styles.loadingMemberGrid}>
      <div className={styles.loadingMemberContainer}>
        <div className={styles.loadingMemberImage} />
        <div className={styles.loadingMemberText} />
      </div>
      <div className={styles.loadingMemberContainer}>
        <div className={styles.loadingMemberImage} />
        <div className={styles.loadingMemberText} />
      </div>
      <div className={styles.loadingMemberContainer}>
        <div className={styles.loadingMemberImage} />
        <div className={styles.loadingMemberText} />
      </div>
      <div className={styles.loadingMemberContainer}>
        <div className={styles.loadingMemberImage} />
        <div className={styles.loadingMemberText} />
      </div>
    </div>
  </div>
);

CommitteeHeader.propTypes = {
  /**
   * Title to display as header
   */
  title: PropTypes.string,
  /**
   * Description under the title
   */
  description: PropTypes.string,
  /**
   * Year in parenthesis next to the title
   */
  year: PropTypes.number,
  /**Bool to tell if the committee is archived (changes select options) */
  archived: PropTypes.bool,
  /**Function that runs when edit is selected */
  onEdit: PropTypes.func,
  /**Function that runs when archive is selected if archived is false or when unarchive is selected if archived is true */
  onArchive: PropTypes.func,
  /**Fucntion that runs when delete is selected */
  onDelete: PropTypes.func,
};
